/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ContentViewerTestDefinitionTestAttemptPayloadCreateResponse,
  ContentViewerTestDefinitionTestAttemptPayloadIndexResponse,
  ContentViewerTestDefinitionTestAttemptPayloadShowResponse,
  ContentViewerTestDefinitionTestAttemptPayloadUpdateResponse,
  ReportingTestAttemptIndexResponse,
  TestAttemptCreate,
} from '../models';
import {
    ContentViewerTestDefinitionTestAttemptPayloadCreateResponseFromJSON,
    ContentViewerTestDefinitionTestAttemptPayloadCreateResponseToJSON,
    ContentViewerTestDefinitionTestAttemptPayloadIndexResponseFromJSON,
    ContentViewerTestDefinitionTestAttemptPayloadIndexResponseToJSON,
    ContentViewerTestDefinitionTestAttemptPayloadShowResponseFromJSON,
    ContentViewerTestDefinitionTestAttemptPayloadShowResponseToJSON,
    ContentViewerTestDefinitionTestAttemptPayloadUpdateResponseFromJSON,
    ContentViewerTestDefinitionTestAttemptPayloadUpdateResponseToJSON,
    ReportingTestAttemptIndexResponseFromJSON,
    ReportingTestAttemptIndexResponseToJSON,
    TestAttemptCreateFromJSON,
    TestAttemptCreateToJSON,
} from '../models';

export interface CompanySpacesReportingTestAttemptsGetRequest {
    userInCompanySpaceId?: Array<number>;
    contentId?: Array<number>;
    state?: CompanySpacesReportingTestAttemptsGetStateEnum;
    startDate?: Date;
    endDate?: Date;
    page?: number;
    perPage?: number;
}

export interface CompanySpacesReportingTestAttemptsXlsxGetRequest {
    userInCompanySpaceId?: Array<number>;
    contentId?: Array<number>;
    state?: CompanySpacesReportingTestAttemptsXlsxGetStateEnum;
    startDate?: Date;
    endDate?: Date;
    page?: number;
    perPage?: number;
}

export interface ContentViewerTestAttemptsGetRequest {
    testDefinitionId: number;
    contentParticipationId: number;
}

export interface ContentViewerTestAttemptsIdGetRequest {
    id: string;
}

export interface ContentViewerTestAttemptsIdPutRequest {
    id: string;
}

export interface ContentViewerTestAttemptsPostRequest {
    body?: TestAttemptCreate;
}

/**
 * 
 */
export class TestAttemptApi extends runtime.BaseAPI {

    /**
     */
    async companySpacesReportingTestAttemptsGetRaw(requestParameters: CompanySpacesReportingTestAttemptsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReportingTestAttemptIndexResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.userInCompanySpaceId) {
            queryParameters['user_in_company_space_id'] = requestParameters.userInCompanySpaceId.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.contentId) {
            queryParameters['content_id'] = requestParameters.contentId.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['start_date'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['end_date'] = (requestParameters.endDate as any).toISOString();
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/reporting/test_attempts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReportingTestAttemptIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesReportingTestAttemptsGet(requestParameters: CompanySpacesReportingTestAttemptsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReportingTestAttemptIndexResponse>> {
        const response = await this.companySpacesReportingTestAttemptsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesReportingTestAttemptsXlsxGetRaw(requestParameters: CompanySpacesReportingTestAttemptsXlsxGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters.userInCompanySpaceId) {
            queryParameters['user_in_company_space_id'] = requestParameters.userInCompanySpaceId.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.contentId) {
            queryParameters['content_id'] = requestParameters.contentId.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['start_date'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['end_date'] = (requestParameters.endDate as any).toISOString();
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/reporting/test_attempts.xlsx`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async companySpacesReportingTestAttemptsXlsxGet(requestParameters: CompanySpacesReportingTestAttemptsXlsxGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.companySpacesReportingTestAttemptsXlsxGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentViewerTestAttemptsGetRaw(requestParameters: ContentViewerTestAttemptsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentViewerTestDefinitionTestAttemptPayloadIndexResponse>>> {
        if (requestParameters.testDefinitionId === null || requestParameters.testDefinitionId === undefined) {
            throw new runtime.RequiredError('testDefinitionId','Required parameter requestParameters.testDefinitionId was null or undefined when calling contentViewerTestAttemptsGet.');
        }

        if (requestParameters.contentParticipationId === null || requestParameters.contentParticipationId === undefined) {
            throw new runtime.RequiredError('contentParticipationId','Required parameter requestParameters.contentParticipationId was null or undefined when calling contentViewerTestAttemptsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.testDefinitionId !== undefined) {
            queryParameters['test_definition_id'] = requestParameters.testDefinitionId;
        }

        if (requestParameters.contentParticipationId !== undefined) {
            queryParameters['content_participation_id'] = requestParameters.contentParticipationId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_viewer/test_attempts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentViewerTestDefinitionTestAttemptPayloadIndexResponseFromJSON));
    }

    /**
     */
    async contentViewerTestAttemptsGet(requestParameters: ContentViewerTestAttemptsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentViewerTestDefinitionTestAttemptPayloadIndexResponse>> {
        const response = await this.contentViewerTestAttemptsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentViewerTestAttemptsIdGetRaw(requestParameters: ContentViewerTestAttemptsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentViewerTestDefinitionTestAttemptPayloadShowResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentViewerTestAttemptsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_viewer/test_attempts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentViewerTestDefinitionTestAttemptPayloadShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentViewerTestAttemptsIdGet(requestParameters: ContentViewerTestAttemptsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentViewerTestDefinitionTestAttemptPayloadShowResponse> {
        const response = await this.contentViewerTestAttemptsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentViewerTestAttemptsIdPutRaw(requestParameters: ContentViewerTestAttemptsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentViewerTestDefinitionTestAttemptPayloadUpdateResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentViewerTestAttemptsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_viewer/test_attempts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentViewerTestDefinitionTestAttemptPayloadUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentViewerTestAttemptsIdPut(requestParameters: ContentViewerTestAttemptsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentViewerTestDefinitionTestAttemptPayloadUpdateResponse> {
        const response = await this.contentViewerTestAttemptsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentViewerTestAttemptsPostRaw(requestParameters: ContentViewerTestAttemptsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentViewerTestDefinitionTestAttemptPayloadCreateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_viewer/test_attempts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TestAttemptCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentViewerTestDefinitionTestAttemptPayloadCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentViewerTestAttemptsPost(requestParameters: ContentViewerTestAttemptsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentViewerTestDefinitionTestAttemptPayloadCreateResponse> {
        const response = await this.contentViewerTestAttemptsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CompanySpacesReportingTestAttemptsGetStateEnum = {
    Invited: 'invited',
    Pending: 'pending',
    Active: 'active',
    Revoked: 'revoked'
} as const;
export type CompanySpacesReportingTestAttemptsGetStateEnum = typeof CompanySpacesReportingTestAttemptsGetStateEnum[keyof typeof CompanySpacesReportingTestAttemptsGetStateEnum];
/**
 * @export
 */
export const CompanySpacesReportingTestAttemptsXlsxGetStateEnum = {
    Invited: 'invited',
    Pending: 'pending',
    Active: 'active',
    Revoked: 'revoked'
} as const;
export type CompanySpacesReportingTestAttemptsXlsxGetStateEnum = typeof CompanySpacesReportingTestAttemptsXlsxGetStateEnum[keyof typeof CompanySpacesReportingTestAttemptsXlsxGetStateEnum];
